<template>
  <div class="container">
    <h1 v-bg-typography="'h1'">{{ title }}</h1>
    <div class="admin__content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.admin__content {
  width: 308px;
  margin-right: 250px;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";

export default {
  name: "AdminLayout",
  directives: {
    BgTypography,
  },
  props: {
    title: String,
  },
};
</script>
